import { __assign, __rest } from "tslib";
import React from 'react';
import { transformWireframeProps } from '../../../../utils/propUtils';
import VeltCommentsSidebarV2ListGroupHeaderLabel from './VeltCommentsSidebarV2ListGroupHeaderLabel/VeltCommentsSidebarV2ListGroupHeaderLabel';
import VeltCommentsSidebarV2ListGroupHeaderCount from './VeltCommentsSidebarV2ListGroupHeaderCount/VeltCommentsSidebarV2ListGroupHeaderCount';
import VeltCommentsSidebarV2ListGroupHeaderSeparator from './VeltCommentsSidebarV2ListGroupHeaderSeparator/VeltCommentsSidebarV2ListGroupHeaderSeparator';
import VeltCommentsSidebarV2ListGroupHeaderChevron from './VeltCommentsSidebarV2ListGroupHeaderChevron/VeltCommentsSidebarV2ListGroupHeaderChevron';
var VeltCommentsSidebarV2ListGroupHeader = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comments-sidebar-list-group-header-v2-wireframe", __assign({}, transformedProps), children));
};
VeltCommentsSidebarV2ListGroupHeader.Label = VeltCommentsSidebarV2ListGroupHeaderLabel;
VeltCommentsSidebarV2ListGroupHeader.Count = VeltCommentsSidebarV2ListGroupHeaderCount;
VeltCommentsSidebarV2ListGroupHeader.Separator = VeltCommentsSidebarV2ListGroupHeaderSeparator;
VeltCommentsSidebarV2ListGroupHeader.Chevron = VeltCommentsSidebarV2ListGroupHeaderChevron;
export default VeltCommentsSidebarV2ListGroupHeader;
